export const initVideoTeasers = (): void => {
  document.querySelectorAll<HTMLElement>('[data-video-teaser]').forEach((teaser) => {
    const openButton = teaser.querySelector<HTMLButtonElement>('[data-video-open]');
    const overlay = teaser.querySelector<HTMLElement>('[data-video-overlay]');
    const closeButton = teaser.querySelector<HTMLButtonElement>('[data-video-close]');

    if (!openButton || !overlay || !closeButton) {
      return;
    }

    const stopPlayback = (): void => {
      overlay.querySelectorAll<HTMLVideoElement>('video').forEach((video) => video.pause());
      overlay.querySelectorAll<HTMLIFrameElement>('iframe').forEach((iframe) => {
        iframe.src = iframe.src;
      });
    };

    const close = (): void => {
      stopPlayback();
      overlay.hidden = true;
      document.documentElement.classList.remove('has-overlay');
      openButton.focus();
    };

    openButton.addEventListener('click', () => {
      overlay.hidden = false;
      document.documentElement.classList.add('has-overlay');
      closeButton.focus();
    });

    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) {
        close();
      }
    });
  });
};
